import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// Fetch nurse services
export const fetchNurseServicesReducer = createAsyncThunk(
  "services/fetchNurseServices",
  async ({ status = "", search = "", page = 1, limit = 10 } = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const queryParamsObj = { page: String(page), limit: String(limit) };
      if (status && status !== "All") queryParamsObj.status = status;
      if (search) queryParamsObj.search = search;
      const queryParams = new URLSearchParams(queryParamsObj).toString();
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseServices}?${queryParams}`;
      const response = await axiosPrivate.get(fullUrl);
      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      }
      const msg = response?.data?.message || i18n.t("toast.failedToFetchServices");
      return rejectWithValue(msg);
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || i18n.t("toast.errorFetchingServices");
      return rejectWithValue(errMsg);
    }
  }
);

// Create a nurse service
export const createNurseServiceReducer = createAsyncThunk(
  "services/createNurseService",
  async (payload, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseServices}`;
      const response = await axiosPrivate.post(fullUrl, payload);
      if (response?.data?.status === true || response?.status === 201 || response?.status === 200) {
        toast.success(response?.data?.message || i18n.t("toast.serviceAddedSuccessfully"));
        return response.data.data;
      }
      const msg = response?.data?.message || i18n.t("toast.failedToAddService");
      toast.error(msg);
      return rejectWithValue(msg);
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || i18n.t("toast.errorAddingTheService");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);

// Update a nurse service
export const updateNurseServiceReducer = createAsyncThunk(
  "services/updateNurseService",
  async ({ id, ...payload }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseServices}/${id}`;
      const response = await axiosPrivate.put(fullUrl, payload);
      if (response?.data?.status === true || response?.status === 200) {
        // No success toast here: the backend emits a real-time notification
        // ("Your service '...' has been updated successfully") which is shown
        // as the single confirmation toast. A local toast would duplicate it.
        return response.data.data;
      }
      const msg = response?.data?.message || i18n.t("toast.failedToUpdateService");
      toast.error(msg);
      return rejectWithValue(msg);
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || i18n.t("toast.errorUpdatingTheService");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);

// Delete a nurse service
export const deleteNurseServiceReducer = createAsyncThunk(
  "services/deleteNurseService",
  async ({ id }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseServices}/${id}`;
      const response = await axiosPrivate.delete(fullUrl);
      if (response?.data?.status === true || response?.status === 200) {
        toast.success(response?.data?.message || i18n.t("toast.serviceRemovedSuccessfully"));
        return response.data.data;
      }
      const msg = response?.data?.message || i18n.t("toast.failedToRemoveService");
      toast.error(msg);
      return rejectWithValue(msg);
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || i18n.t("toast.errorRemovingTheService");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);
